<template>
	<vs-popup
		:title="$t(isLastStage ? 'orderClosureStatus' : 'payRewardToAuthor')"
		class="set-ticket-done"
		:active.sync="activeProp"
	>
	<div
			v-if="currentStage && currentStage.marginality_correct === false"
			class="marginality-warning bg-warning"
		>
			{{ $t("marginalityWarning") }}
		</div>

		<div v-if="isLastStage">

			<div class="closure-status">
				<label class="vs-input--label">{{ $t('orderClosureStatus') }}</label>
				<v-select
					v-model="closure_status"
					v-validate="'required'"
					name="closureStatus"
					label="name"
					:options="closureStatus"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:reduce="item => item.value">
				</v-select>
				<span v-if="errors.first('closureStatus')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="comment-text my-3">
				<label class="vs-input--label">{{ $t('comment') }}</label>

				<vs-textarea
					v-model="comment"
					v-validate="'required|min:100'"
					class="w-full"
					name="comment"
					type="textarea"
				>
				</vs-textarea>
				<span v-if="errors.first('comment')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>


		</div>


		{{ $t("recommendedPaymentSum") }}: {{ recommendedPrice }}
		<!-- <vs-input
			:label="$t('authorsReward')"
			v-model="reward"
			class="mt-3"
		/> -->

		<vs-checkbox v-model="notNotifyClientState" class="mt-2 mx-0">
			{{ $t("doNotNotifyClient") }}
		</vs-checkbox>

		<div class="set-ticket-done__controls">
			<vs-button :disabled="loading || !isFormValid" color="success" @click="confirm">
				{{ $t(isLastStage ? "closeOrder" : "pay") }}
			</vs-button>

			<vs-custom-button
				:disabled="loading"
				color="#9a9a9a"
				type="flat"
				@click="close"
			>
				{{ $t("doCancel") }}
			</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "SetStageDonePopup",
	props: {
		active: { default: false, type: Boolean },
		notNotifyClient: { default: false, type: Boolean },
		loading: { default: false, type: Boolean },
		recommendedPrice: { default: 0 },
		currentStage: { default: null },
		isLastStage: { default: false, type: Boolean },
	},
	components: {
		vSelect,
	},
	data() {
		return {
			reward: 0,
			closure_status: "",
			comment: "",
		};
	},
	// watch: {
	// 	activeProp(newValue) {
	// 		if(newValue === false) {
	// 			this.reward = 0;
	// 		}
	// 	}
	// },
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},

		notNotifyClientState: {
			get() {
				return this.notNotifyClient;
			},
			set(val) {
				this.$emit("update:notNotifyClient", val);
			}
		},
		closureStatus() {
			return [
				{
					name: this.$t('verySatisfied'),
					value: 'very_satisfied',
				},
				{
					name: this.$t('satisfied'),
					value: 'satisfied',
				},
				{
					name: this.$t('dissatisfied'),
					value: 'dissatisfied',
				},
				{
					name: this.$t('neutralNoFeedback'),
					value: 'neutral_no_feedback',
				},
				{
					name: this.$t('neutralMinorCorrections'),
					value: 'neutral_minor_corrections',
				},
				{
					name: this.$t('neutralCompromiseSolution'),
					value: 'neutral_compromise_solution',
				},
				{
					name: this.$t('neutralResolvedIssue'),
					value: 'neutral_resolved_issue',
				},
			];
		},
		isFormValid() {
			if (this.isLastStage) {
				return (
					this.closure_status &&
					this.comment &&
					this.comment.length >= 100 &&
					!this.errors.any()
				);
			}

			return true;
		},
	},
	methods: {
		confirm() {
			if (!this.recommendedPrice) return;

			this.$emit("confirm", this.recommendedPrice, this.closure_status, this.comment);
		},

		close() {
			this.activeProp = false;
		}
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-done {
	.vs-textarea {
		max-height: 13rem;
	}
	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $success;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}

	.vs-input {
		width: 100%;
	}

	.vs-input--label {
		transition: color 0.3s ease;
	}

	.vs-input-primary.isFocus .vs-input--label {
		color: $success;
	}

	.vs-input-primary .vs-input--input:focus {
		border-color: $success !important;
	}

	.marginality-warning {
		border-radius: 4px;
		text-align: center;
		padding: 5px 0;
		margin-bottom: 15px;
	}
}
</style>
